export { default } from './IconaMedia';
